import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import Badge from 'react-bootstrap/lib/Badge';
import AriAvatar from 'containers/Ari/AriAvatar';
import { trackEvent } from 'helpers/Analytics';
import styles from './AriUpsell.module.scss';

const AriUpsell = ({ user, mobile }) => {
  const isLoggedIn = !!user;

  const handleClick = () => {
    trackEvent('ari-sidebar-clicked');
  };

  return (
    <div
      className={`${styles.upsellContainer} ${
        mobile ? styles.upsellMobile : styles.upsellDesktop
      }`}
    >
      <div className={styles.headerRow}>
        <AriAvatar size={36} className={styles.avatar} />
        <p className={styles.upsellTitle}>
          Ari: your job agent
          {isLoggedIn && (
            <Badge
              className={styles.newBadge}
              style={{ backgroundColor: '#0777DA' }}
            >
              New
            </Badge>
          )}
        </p>
      </div>
      <p>
        {isLoggedIn
          ? 'Ari searches millions of jobs across the web and matches them to your portfolio. Free to try.'
          : 'Ari reads your portfolio and searches millions of jobs across the web to find work that fits you. Free for Twine freelancers.'}
      </p>
      <Button
        href={isLoggedIn ? '/ari' : '/freelance/ari'}
        className={styles.upsellButton}
        bsStyle="primary"
        onClick={handleClick}
      >
        {isLoggedIn ? 'Ask Ari to search' : 'Meet Ari'}
      </Button>
    </div>
  );
};

AriUpsell.propTypes = {
  user: PropTypes.object,
  mobile: PropTypes.bool,
};

AriUpsell.defaultProps = {
  mobile: false,
};

export default AriUpsell;
